import { SizableText, Label, XStack, YStack } from '@mythical/ui'
import useMutation from 'app/hooks/use-mutation'
import { reportMutation, reportResult } from 'app/mutations/comments/report'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { Button } from 'app/components/primitive/Button'
import { StyledDialog } from 'app/components/primitive/StyledDialog'
import { Input } from 'app/components/primitive/Form'

const query = reportMutation()

interface Props {
  id: string
  modalOpen: boolean
  onReport: () => void
  setModalOpen: (open: boolean) => void
}

export const ReportModal = observer<Props>(
  ({ id, modalOpen, onReport, setModalOpen }) => {
    const [reason, setReason] = useState('')
    const { loading, data, error, makeRequest } = useMutation(
      query,
      reportResult,
    )

    const handleReport = async () => {
      const data = await makeRequest({ id, reason: reason.trim() })

      if (data?.success) {
        onReport()
        setModalOpen(false)
      }
    }

    return (
      <StyledDialog
        open={modalOpen}
        onOpenChange={(open) => setModalOpen(open)}
        title="Report Comment"
        description="Please provide a reason for reporting this comment."
      >
        <YStack gap="$3">
          <Label size="$3" height="auto" lineHeight="$3" htmlFor="reason">
            Report Reason
          </Label>
          <Input
            id="reason"
            size="$3"
            multiline
            placeholder="Reason"
            onChangeText={(e) => setReason(e)}
            onSubmitEditing={onReport}
          />
        </YStack>

        {(error || (data && !data.success)) && (
          <SizableText color="$fgError" ta='center'>
            {error?.message || data?.reason || 'Unknown Error'}
          </SizableText>
        )}

        <XStack gap="$2" jc="center">
          <Button theme="secondary" onPress={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button theme="primary" onPress={handleReport} loading={loading}>
            {!data?.success && 'Report'}
            {data && data.success && 'Reported'}
          </Button>
        </XStack>
      </StyledDialog>
    )
  },
)
